import { useForceUpdate } from '@epam/uui-core'
import L from 'leaflet'
import { useEffect, useRef } from 'react'
import { Polygon, Tooltip } from 'react-leaflet'
import { LocationResponse } from '../../../../constants/types'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'
import { useGetLocationMutation } from '../../../../store'

export const Locations = () => {
  const [fetchLocation] = useGetLocationMutation()
  const { showLocationInfo } = useSideBarControlls()
  const { selectedLocationsIds, selectedLocationId } = useAppSelector(
    (state) => state.locations
  )
  const locationsRef = useRef<Map<number, LocationResponse>>(
    new Map<number, LocationResponse>()
  )
  const forceUpdate = useForceUpdate()

  useEffect(() => {
    if (selectedLocationsIds.length === 0) {
      locationsRef.current.clear()
    }

    locationsRef.current.forEach((_, key) => {
      if (!selectedLocationsIds.includes(key)) {
        locationsRef.current.delete(key)
      }
    })

    forceUpdate()

    for (const locId of selectedLocationsIds) {
      if (!locationsRef.current?.has(locId)) {
        fetchLocation({ locationId: locId, withPoints: true })
          .unwrap()
          .then((value) => {
            if (value?.length > 0) {
              locationsRef.current.set(locId, value[0])
              forceUpdate()
            } else {
              console.error(`Error during fetching points for ${locId}`)
            }
          })
      }
    }
  }, [selectedLocationsIds, fetchLocation, forceUpdate])

  return (
    <>
      {locationsRef &&
        Array.from(locationsRef.current.values()).map((location) => {
          return (
            <Polygon
              key={location.id}
              positions={location.points}
              eventHandlers={{
                click: (event: L.LeafletMouseEvent) => {
                  L.DomEvent.stopPropagation(event)
                  fetchLocation({ locationId: location.id })
                    .unwrap()
                    .then((value) => {
                      if (value?.length > 0) {
                        showLocationInfo(value[0])
                      }
                    })
                },
              }}
              pathOptions={
                selectedLocationId === location.id
                  ? { color: 'lime' }
                  : { color: 'blue' }
              }
            >
              <Tooltip direction="bottom">{location.name}</Tooltip>
            </Polygon>
          )
        })}
    </>
  )
}
